import { BiImageAdd } from 'react-icons/bi';
import {
  FaAddressBook,
  FaBox,
  FaBoxOpen,
  FaBuilding,
  FaBullhorn,
  FaFileAlt,
  FaFileInvoiceDollar,
  FaHome,
  FaPlusSquare,
  FaShoppingCart,
  FaUser,
  FaUserFriends,
  FaUsers,
} from 'react-icons/fa';
import { IconType } from 'react-icons/lib';
import { MdAddLink, MdOutlineNoteAdd, MdVideoCall } from 'react-icons/md';

export enum COMMAND_TYPE {
  ACTION = 'action',
  REDIRECT = ' redirect',
}

export enum COMMAND_CATEGORY {
  CREATE = 'create',
  GO_TO = 'go_to',
  ADD = 'add',
}

export type Command = {
  name: string;
  value: COMMAND_PROCESS;
  keys: { default: string[]; mac: string[] };
  iconName: IconType;
  type: COMMAND_TYPE;
  category: COMMAND_CATEGORY;
};

export enum COMMAND_PROCESS {
  CREATE_PORTAL = 'create_portal',
  CREATE_PRODUCT = 'create_product',
  CREATE_CONTACT = 'create_contact',
  CREATE_CATALOGUE = 'create_catalogue',
  CREATE_NEWSLETTER = 'create_newsletter',
  GO_HOME = 'go_home',
  GO_PROFILE = 'go_profile',
  GO_PORTAL = 'go_portal',
  GO_CATALOGUE = 'go_catalogue',
  GO_BUSINESS = 'go_business',
  GO_CONTACT = 'go_contact',
  GO_CAMPAIGN_MANAGER = 'go_campaign_manager',
  GO_ORDERS = 'go_orders',
  GO_INVOICES = 'go_invoices',
  GO_PRODUCTS = 'go_products',
  GO_CUSTOMERS = 'go_customers',
  GO_MEMBERS = 'go_members',
  ADD_IMAGE = 'add_image',
  ADD_VIDEO = 'add_video',
  ADD_NOTE = 'add_note',
  ADD_LINK = 'add_link',
}

export const Commands: Command[] = [
  {
    name: 'Create new Portal',
    value: COMMAND_PROCESS.CREATE_PORTAL,
    iconName: FaPlusSquare,
    keys: { default: ['Control', 'Shift', 'N'], mac: ['Meta', 'Shift', 'N'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.CREATE,
  },
  {
    name: 'Create new Product',
    value: COMMAND_PROCESS.CREATE_PRODUCT,
    iconName: FaBox,
    keys: { default: ['Control', 'Shift', 'P'], mac: ['Meta', 'Shift', 'P'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.CREATE,
  },
  {
    name: 'Create new Contact',
    value: COMMAND_PROCESS.CREATE_CONTACT,
    iconName: FaAddressBook,
    keys: { default: ['Control', 'Shift', 'C'], mac: ['Meta', 'Shift', 'C'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.CREATE,
  },
  {
    name: 'Create new Catalogue',
    value: COMMAND_PROCESS.CREATE_CATALOGUE,
    iconName: FaFileAlt,
    keys: { default: ['Control', 'Shift', 'T'], mac: ['Meta', 'Shift', 'T'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.CREATE,
  },
  {
    name: 'Go to Home',
    value: COMMAND_PROCESS.GO_HOME,
    iconName: FaHome,
    keys: { default: ['Alt', 'Shift', 'H'], mac: ['Alt', 'Shift', 'H'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Profile',
    value: COMMAND_PROCESS.GO_PROFILE,
    iconName: FaUser,
    keys: { default: ['Alt', 'Shift', 'A'], mac: ['Alt', 'Shift', 'A'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Portal',
    value: COMMAND_PROCESS.GO_PORTAL,
    iconName: FaBuilding,
    keys: { default: ['Alt', 'Shift', 'N'], mac: ['Alt', 'Shift', 'N'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  // {
  //   name: 'Go to Product',
  //   value: COMMAND_PROCESS.GO_PRODUCT,
  //   iconName: FaBox,
  //   keys: { default: ['Alt', 'Shift', 'P'], mac: ['Alt', 'Shift', 'P'] },
  //   type: COMMAND_TYPE.REDIRECT,
  //   category: COMMAND_CATEGORY.GO_TO,
  // },
  {
    name: 'Go to Catalogue',
    value: COMMAND_PROCESS.GO_CATALOGUE,
    iconName: FaFileAlt,
    keys: { default: ['Alt', 'Shift', 'T'], mac: ['Alt', 'Shift', 'T'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Business',
    value: COMMAND_PROCESS.GO_BUSINESS,
    iconName: FaBuilding,
    keys: { default: ['Alt', 'Shift', 'B'], mac: ['Alt', 'Shift', 'B'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  // {
  //   name: 'Go to Contact',
  //   value: COMMAND_PROCESS.GO_CONTACT,
  //   iconName: FaAddressBook,
  //   keys: { default: ['Alt', 'Shift', 'C'], mac: ['Alt', 'Shift', 'C'] },
  //   type: COMMAND_TYPE.REDIRECT,
  //   category: COMMAND_CATEGORY.GO_TO,
  // },
  {
    name: 'Go to Campaign Manager',
    value: COMMAND_PROCESS.GO_CAMPAIGN_MANAGER,
    iconName: FaBullhorn,
    keys: { default: ['Alt', 'Shift', 'M'], mac: ['Alt', 'Shift', 'M'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Orders',
    value: COMMAND_PROCESS.GO_ORDERS,
    iconName: FaShoppingCart,
    keys: { default: ['Alt', 'Shift', 'O'], mac: ['Alt', 'Shift', 'O'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Invoices',
    value: COMMAND_PROCESS.GO_INVOICES,
    iconName: FaFileInvoiceDollar,
    keys: { default: ['Alt', 'Shift', 'I'], mac: ['Alt', 'Shift', 'I'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Products',
    value: COMMAND_PROCESS.GO_PRODUCTS,
    iconName: FaBoxOpen,
    keys: { default: ['Alt', 'Shift', 'P'], mac: ['Alt', 'Shift', 'P'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Customers',
    value: COMMAND_PROCESS.GO_CUSTOMERS,
    iconName: FaUsers,
    keys: { default: ['Alt', 'Shift', 'C'], mac: ['Alt', 'Shift', 'C'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },
  {
    name: 'Go to Members',
    value: COMMAND_PROCESS.GO_MEMBERS,
    iconName: FaUserFriends,
    keys: { default: ['Alt', 'Shift', 'D'], mac: ['Alt', 'Shift', 'D'] },
    type: COMMAND_TYPE.REDIRECT,
    category: COMMAND_CATEGORY.GO_TO,
  },

  {
    name: 'Add Image',
    value: COMMAND_PROCESS.ADD_IMAGE,
    iconName: BiImageAdd,
    keys: { default: ['Control', 'Alt', 'i'], mac: ['Meta', 'Alt', 'i'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.ADD,
  },
  {
    name: 'Add Video',
    value: COMMAND_PROCESS.ADD_VIDEO,
    iconName: MdVideoCall,
    keys: { default: ['Control', 'Alt', 'v'], mac: ['Meta', 'Alt', 'v'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.ADD,
  },
  {
    name: 'Add Note',
    value: COMMAND_PROCESS.ADD_NOTE,
    iconName: MdOutlineNoteAdd,
    keys: { default: ['Control', 'Alt', 'n'], mac: ['Meta', 'Alt', 'n'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.ADD,
  },
  {
    name: 'Add Link',
    value: COMMAND_PROCESS.ADD_LINK,
    iconName: MdAddLink,
    keys: { default: ['Control', 'Alt', 'l'], mac: ['Meta', 'Alt', 'l'] },
    type: COMMAND_TYPE.ACTION,
    category: COMMAND_CATEGORY.ADD,
  },
];
